import { get } from "lodash";

export const shouldShowMaximumRelease = loan => Boolean(get(loan, "covenants.maximumRelease"));

export const shouldShowAllocations = loan => Boolean(get(loan, "covenants.allocations"));

export const shouldShowNotice = loan => Boolean(get(loan, "covenants.notice"));

export const shouldShowConditions = loan => Boolean(get(loan, "covenants.conditions"));

export const shouldShowPartialReleaseMisc = loan => Boolean(get(loan, "covenants.partialReleaseMisc"));
